import { empresa } from "./state";

/**
 * Establecer un valor para generales
 */
export function establecerEmpresa(state, empresa) {
  state.empresa = empresa;
}

/**
 * Mutación para resetear el formulario de banners.
 *
 * @export
 * @param {*} state
 */
export function resetBannerEmpresa(state) {
  Object.assign(state.empresa, empresa())
}